// extracted by mini-css-extract-plugin
export default {"infoContainer":"basket-modal_infoContainer__5yxOQ","textContainer":"basket-modal_textContainer__Ll-VQ"};